import { Box } from '@mui/material';
import React from 'react';
import List from '../../Components/List/List';
import { workMdIndex } from '../../utils/fileIndex';

export default function WorkExperiences(){
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <List items={workMdIndex} updatedText={''}/>
        </Box>
    );
}